import React from "react";

const SvgBell = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg-icon" {...props}>
    <path
      d="M17.5 15.8333H19.1667V17.5H0.833344V15.8333H2.50001V3.33333C2.50001 2.8731 2.87311 2.5 3.33334 2.5H11.6667C12.1269 2.5 12.5 2.8731 12.5 3.33333V15.8333H15.8333V9.16667H14.1667V7.5H16.6667C17.1269 7.5 17.5 7.8731 17.5 8.33333V15.8333ZM4.16668 4.16667V15.8333H10.8333V4.16667H4.16668ZM5.83334 9.16667H9.16668V10.8333H5.83334V9.16667ZM5.83334 5.83333H9.16668V7.5H5.83334V5.83333Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgBell;
